import Vue from 'vue'

const storage = {
  set: (cName, cValue, days = 365) => {
    const d = new Date()
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = 'expires=' + d.toUTCString()
    document.cookie = cName + '=' + cValue + ';' + expires + ';path=/'
  },
  get: (name) => {
    const cookieArr = document.cookie.split(';')

    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split('=')

      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1])
      }
    }

    return null
  }
}

Vue.prototype.$cookie = storage
